module.exports = __webpack_public_path__ + "img/ad2.847384fd.jpg";